export default __webpack_public_path__ + "static/media/walletconnect.840c4e65.svg";